import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { CpCompareSidebarService, MeasureCard } from '@pages/control-page/control-page-main/control-page-compare/cp-compare-sidebar/cp-compare-sidebar.service';
import { combineLatest, map } from 'rxjs';

@Component({
  selector: 'app-cp-compare-measure-card',
  templateUrl: './cp-compare-measure-card.component.html',
  styleUrls: ['./cp-compare-measure-card.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class CpCompareMeasureCardComponent {

  @Input() measureCard: MeasureCard;

  private selected$ = this.compareSidebarService.measureCards$.pipe(
    map(selectedMeasureCards => this.isSelected(selectedMeasureCards))
  );

  viewModel$ = combineLatest({
    selected: this.selected$,
  });

  constructor(
    private compareSidebarService: CpCompareSidebarService,
  ) {}

  isSelected(selectedMeasureCards: MeasureCard[]) {
    return selectedMeasureCards.some(card => {
      const cardId = card.home?.id ?? card.room?.id ?? card.module?.id;
      const measureCardId = this.measureCard.home?.id ?? this.measureCard.room?.id ?? this.measureCard.module?.id;
      return cardId === measureCardId && card.measureType === this.measureCard.measureType;
    });
  }

  selectMeasureCard(selected: boolean) {
    if (!selected) {
      this.compareSidebarService.selectCard(this.measureCard);
    }
    else {
      this.compareSidebarService.unSelectCard(this.measureCard);
    }
  }

}
